"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyCompanyBillingFieldsFromSubscription = exports.subscriptionBillingConfigStampFromCompany = exports.resolveTrialPeriodDefaults = exports.subscriptionHasAuthoritativeTrialDefaults = exports.resolveInterimBillingInterval = exports.subscriptionHasAuthoritativeInterimBilling = void 0;
function subscriptionHasAuthoritativeInterimBilling(sub) {
    return (sub === null || sub === void 0 ? void 0 : sub.interimBillingInterval) != null;
}
exports.subscriptionHasAuthoritativeInterimBilling = subscriptionHasAuthoritativeInterimBilling;
function resolveInterimBillingInterval(params) {
    var _a;
    if (subscriptionHasAuthoritativeInterimBilling(params.subscription)) {
        return (_a = params.subscription.interimBillingInterval) !== null && _a !== void 0 ? _a : null;
    }
    return null;
}
exports.resolveInterimBillingInterval = resolveInterimBillingInterval;
function subscriptionHasAuthoritativeTrialDefaults(sub) {
    return (sub === null || sub === void 0 ? void 0 : sub.trialPeriodMode) != null;
}
exports.subscriptionHasAuthoritativeTrialDefaults = subscriptionHasAuthoritativeTrialDefaults;
function resolveTrialPeriodDefaults(params) {
    var _a, _b;
    if (subscriptionHasAuthoritativeTrialDefaults(params.subscription)) {
        return {
            trialPeriodMode: (_a = params.subscription.trialPeriodMode) !== null && _a !== void 0 ? _a : null,
            trialPeriodDays: (_b = params.subscription.trialPeriodDays) !== null && _b !== void 0 ? _b : null,
        };
    }
    return {
        trialPeriodMode: null,
        trialPeriodDays: null,
    };
}
exports.resolveTrialPeriodDefaults = resolveTrialPeriodDefaults;
/** Legacy migration helper. Runtime readers should use CompanySubscription fields. */
function subscriptionBillingConfigStampFromCompany(company) {
    var _a, _b, _c;
    return {
        interimBillingInterval: (_a = company === null || company === void 0 ? void 0 : company.paymentsInterimBillingInterval) !== null && _a !== void 0 ? _a : null,
        trialPeriodMode: (_b = company === null || company === void 0 ? void 0 : company.trialPeriodMode) !== null && _b !== void 0 ? _b : null,
        trialPeriodDays: (_c = company === null || company === void 0 ? void 0 : company.trialPeriodDays) !== null && _c !== void 0 ? _c : null,
    };
}
exports.subscriptionBillingConfigStampFromCompany = subscriptionBillingConfigStampFromCompany;
/** Mirror subscription billing config back to legacy company scalars. */
function legacyCompanyBillingFieldsFromSubscription(sub) {
    var _a, _b, _c;
    return {
        paymentsInterimBillingInterval: (_a = sub === null || sub === void 0 ? void 0 : sub.interimBillingInterval) !== null && _a !== void 0 ? _a : null,
        trialPeriodMode: (_b = sub === null || sub === void 0 ? void 0 : sub.trialPeriodMode) !== null && _b !== void 0 ? _b : null,
        trialPeriodDays: (_c = sub === null || sub === void 0 ? void 0 : sub.trialPeriodDays) !== null && _c !== void 0 ? _c : null,
    };
}
exports.legacyCompanyBillingFieldsFromSubscription = legacyCompanyBillingFieldsFromSubscription;
